import type { MatchDetailed } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'
import type { MatchExclusion } from '../update-match-exclusion'

// Optional while the API and UI are rolled out independently.
export type MatchDetailsWithExclusion = MatchDetailed & { exclusion?: MatchExclusion }

function getMatchDetails(matchId: string): Promise<MatchDetailsWithExclusion> {
  return requestApiJsonOrThrow<MatchDetailsWithExclusion>(`admin/matches/${matchId}`)
}

export const matchDetailsQuery = (matchId: string) => ({
  queryKey: ['match', matchId],
  queryFn: () => getMatchDetails(matchId),
})
